/* 22.09.2026 (blog reboot): «Load more» на індексі блогу замість пагінації цифрами.
   Пагінація лишається в розмітці (SEO і робота без JS) - цей скрипт її ховає і додає кнопку,
   яка фетчить наступну сторінку, дістає з неї картки і додає у сітку. Історія оновлюється
   через replaceState, щоб кнопка «назад» не викидала на першу сторінку. */
document.addEventListener('DOMContentLoaded', function () {
  var holder = document.querySelector('[data-blog-more]');
  var grid = document.querySelector('[data-blog-grid]');
  if (!holder || !grid) return;

  var pagination = document.querySelector('.blog-pagination');
  var next = holder.dataset.next;
  if (!next) { if (pagination) pagination.hidden = true; return; }
  if (pagination) pagination.hidden = true;

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn btn-primary blog-more__btn';
  btn.textContent = holder.dataset.label || 'Load more';
  holder.appendChild(btn);

  var loading = false;
  btn.addEventListener('click', function () {
    if (loading || !next) return;
    loading = true;
    btn.classList.add('is-loading');
    btn.textContent = holder.dataset.loading || 'Loading…';

    fetch(next, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-blog-grid] > .blog-card');
        for (var i = 0; i < cards.length; i++) grid.appendChild(cards[i]);
        var nextHolder = doc.querySelector('[data-blog-more]');
        var url = next;
        next = nextHolder ? nextHolder.dataset.next : '';
        try { history.replaceState(null, '', url); } catch (e) {}
        if (typeof window.psTrack === 'function') window.psTrack('blog_load_more', { page: url }, null);
        if (next) {
          btn.textContent = holder.dataset.label || 'Load more';
          btn.classList.remove('is-loading');
        } else {
          btn.remove();
        }
        loading = false;
      })
      .catch(function () {
        btn.textContent = holder.dataset.label || 'Load more';
        btn.classList.remove('is-loading');
        loading = false;
        if (pagination) pagination.hidden = false;
      });
  });
});

/* 22.09.2026: Popular - клас is-scrolled для верхнього затухання, щоб зрізаний рядок виглядав навмисним */
document.addEventListener('DOMContentLoaded', function () {
  var list = document.querySelector('[data-blog-popular]');
  var aside = list && list.closest('.blog-featured__aside');
  if (!aside) return;
  var sync = function () { aside.classList.toggle('is-scrolled', list.scrollTop > 4); };
  list.addEventListener('scroll', sync, { passive: true });
  sync();
});

/* 22.09.2026: слайдер останніх статей у featured-колонці (5 карток, стрілки + свайп) */
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.swiper-blog-latest');
  if (!el || !window.Swiper) return;
  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 16,
    autoHeight: false,
    watchOverflow: true,
    pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
    navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') }
  });
});
